<template>
  <div v-if="empresa">
    <div>
      {{ empresa.pessoa.nome }}
    </div>
    <div>
      {{ empresa.pessoa.cnpj | cnpj }}
    </div>
    <div>
      {{ empresa.endereco | endereco }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    empresa: Object,
  },
};
</script>
